import React, { useEffect, useState } from "react";
import MainLayout from "../components/MainLayout";
import { mainTable } from "../css/Common";
import InputText from "../ReusableComponents/InputText";
import { BindAPI, BindPostAPI, IUDAPI } from "../services/APIConnection";
import ReportGridPage from "../components/ReportGridPage";
import MultiSelect from "../ReusableComponents/MultiSelect";
import * as XLSX from "sheetjs-style";
import { useUserCapability } from "../components/ConstantReducerProvider";
import {
  enquiryReportHeaders,
  stockLedgerReportHeaders,
} from "../components/HeaderAttribute";
import AutoDropDown from "../ReusableComponents/AutoCompleteDropDown";

const StockLedgerReport = () => {
  const { userProfileState } = useUserCapability();
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const mstClientId =
    sessionStorage.getItem("MstClientId") &&
      sessionStorage.getItem("MstClientId") !== "null"
      ? Number(sessionStorage.getItem("MstClientId"))
      : 0;
  const [stockLedgerReportFields, setStockLedgerReportFields] = useState({
    itemType: '',
    itemCategory: '',
    item: '',
  });
  const [stockLedgerReportFieldsError, setStockLedgerReportFieldsError] =
    useState({
      itemTypeError: "",
      itemCategoryError: "",
      itemError: "",
    });
  const [bindStockLedgerReports, setBindStockLedgerReports] = useState([]);
  const [showTable, setShowTable] = useState(false);

  const [bindItemType, setBindItemType] = useState([]);
  const [bindItemCategory, setBindItemCategory] = useState([]);
  const [bindItem, setBindItem] = useState([]);


  const [bindItemCategoryDD, setBindItemCategoryDD] = useState([]);
  const [bindItemDD, setBindItemDD] = useState([]);

  const GoButton = async () => {
    
    const itemTypeValidate = stockLedgerReportFields.itemType
      ? ""
      : "Select Item Type";
    const itemCategoryValidate = stockLedgerReportFields.itemCategory
      ? ""
      : "Select Item Category";

    const itemValidate = stockLedgerReportFields.item ? "" : "Select Item";

    setStockLedgerReportFieldsError({
      ...stockLedgerReportFieldsError,
      itemTypeError: itemTypeValidate,
      itemCategoryError: itemCategoryValidate,
      itemError: itemValidate,
    });


    if (!itemTypeValidate && !itemCategoryValidate && !itemValidate) {
      const ReportData = {
        itemType: stockLedgerReportFields.itemType,
        itemCategory: stockLedgerReportFields.itemCategory,
        item: stockLedgerReportFields.item,
        fromDate: fromDate,
        toDate: toDate,
        mstClientId: mstClientId,
      };
      const response = await BindPostAPI(
        ReportData,
        "StockReportAPI/StockLedgerReport"
      );

      setBindStockLedgerReports(response.data.Table);
      setShowTable(true);
    } else {
    }
  };


  const createdBy = sessionStorage.getItem("createdBy");
  const clientId = sessionStorage.getItem("MstClientId");

  const handleExport = async () => {
    

    try {
      const dateRange = {
        fromDate: fromDate,
        toDate: toDate,
      };

      const selectedOptionsData = {
        itemType: bindItemType.filter(
          (x) => x.value === stockLedgerReportFields.itemType
        ),
        itemCategory: bindItemCategoryDD.filter(
          (x) => x.value === stockLedgerReportFields.itemCategory
        ),
        item: bindItemDD.filter(
          (x) => x.value === stockLedgerReportFields.item
        ),
      };

      // Export Function
      await exportData(
        stockLedgerReportHeaders.map((column) => column.title),
        bindStockLedgerReports,
        dateRange,
        selectedOptionsData
      );

      // ✅ Success Log
      await IUDAPI(
        {
          mstClientId: parseInt(clientId, 10),
          mstUserId: parseInt(createdBy, 10),
          sp: "Stock Ledger Report",
          action: "Excel Export",
          status: "SUCCESS",
          tableName: "",
          description: `Stock Ledger Report Excel exported successfully, From ${fromDate} to ${toDate}`,
        },
        "LogAPI/IUDLog"
      );

      console.log("Stock Ledger Report Excel export completed successfully");
    } catch (error) {
      console.error("Stock Ledger Report Excel export failed:", error);

      // ❌ Failed Log
      await IUDAPI(
        {
          mstClientId: parseInt(clientId, 10),
          mstUserId: parseInt(createdBy, 10),
          sp: "Stock Ledger Report",
          action: "Excel Export",
          status: "FAILED",
          tableName: "",
          description: `Stock Ledger Report Excel export failed - ${error?.message || "Unknown Error"
            }`,
        },
        "LogAPI/IUDLog"
      );
    }
  };


  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const date = new Date(dateStr);
    return `${date.getDate().toString().padStart(2, "0")}-${(
      date.getMonth() + 1
    )
      .toString()
      .padStart(2, "0")}-${date.getFullYear()}`;
  };
  const exportData = (columns, rows, dateRange, selectedDetails) => {

    // 🔹 Title Row (5 columns to match structure)
    const titleRow = [
      { v: "Stock Ledger Report", s: { font: { bold: true, sz: 16 } } },
      { v: "" }, { v: "" }, { v: "" }, { v: "" }
    ];

    // 🔹 Date Range Row
    const dateRangeRow = [
      { v: "From date", s: { font: { bold: true } } },
      { v: formatDate(dateRange.fromDate) },
      { v: "" },
      { v: "To date", s: { font: { bold: true } } },
      { v: formatDate(dateRange.toDate) }
    ];

    // 🔹 Services Rows (FIXED - multiple rows)
    const servicesRows = [
      [
        { v: "Item Type", s: { font: { bold: true } } },
        { v: selectedDetails.itemType[0]?.label || "" },
        { v: "" }, { v: "" }, { v: "" }
      ],
      [
        { v: "Item Category", s: { font: { bold: true } } },
        { v: selectedDetails.itemCategory[0]?.label || "" },
        { v: "" }, { v: "" }, { v: "" }
      ],
      [
        { v: "Item Name", s: { font: { bold: true } } },
        { v: selectedDetails.item[0]?.label || "" },
        { v: "" }, { v: "" }, { v: "" }
      ]
    ];


    // 🔹 Header Row
    const headerRow = columns.map((column) => ({
      v: column,
      s: {
        fill: { fgColor: { rgb: "000000" } },
        font: { bold: true, color: { rgb: "FFFFFF" } },
        alignment: { horizontal: "left" }
      }
    }));

    // 🔹 Data Rows
    const dataRows = rows.map((rowData, index) => {
      const isAlternate = index % 2 === 1;

      const baseStyle = isAlternate
        ? { fill: { fgColor: { rgb: "F0F0F0" } } }
        : {};

      return [
        {
          v: index + 1,
          s: { ...baseStyle, alignment: { horizontal: "left" } }
        },
        {
          v: rowData.Date,
          s: { ...baseStyle, alignment: { horizontal: "left" } }
        },
        {
          v: rowData.TxnType,
          s: { ...baseStyle, alignment: { horizontal: "left" } }
        },
        {
          v: rowData.Qty,
          s: {
            ...baseStyle,
            alignment: { horizontal: "left" },
            font: {
              color: {
                rgb: ["Damage", "Issue", "Consumption"].includes(rowData.TxnType)
                  ? "FF0000"
                  : "000000"
              }
            }
          }
        },
        {
          v: rowData.Balance,
          s: {
            ...baseStyle,
            alignment: { horizontal: "left" },
            font: {
              color: {
                rgb: rowData.Balance <= rowData.ReOrderLevel ? "FF0000" : "000000"
              }
            }
          }
        }
      ];
    });
    const emptyRow = [{ v: "" }, { v: "" }, { v: "" }, { v: "" }, { v: "" }];
    // 🔹 Combine All Data
    const wsData = [
      titleRow,
      dateRangeRow,
      emptyRow,
      ...servicesRows,
      emptyRow,
      headerRow,
      ...dataRows
    ];

    const ws = XLSX.utils.aoa_to_sheet(wsData);

    // 🔹 Column Widths (MATCHING 5 COLUMNS ONLY ✅)
    ws["!cols"] = [
      { width: 10 }, // S.No
      { width: 20 }, // Date / Label
      { width: 25 }, // Txn Type / Value
      { width: 15 }, // Qty
      { width: 15 }  // Balance
    ];

    // 🔹 Row Heights
    ws["!rows"] = [
      { hpt: 30 }, // Title
      { hpt: 20 }, // Date
      { hpt: 15 }, // empty
      { hpt: 20 }, // Item Type
      { hpt: 20 }, // Item Category
      { hpt: 20 }, // Item Name ✅ INCREASED
      { hpt: 15 }, // empty
      { hpt: 20 }, // header
      ...Array(rows.length).fill({ hpt: 18 })
    ];

    // 🔹 Merges (for clean UI like image)
    ws["!merges"] = [
      // Title
      { s: { r: 0, c: 0 }, e: { r: 0, c: 4 } },

      // Item Type
      { s: { r: 3, c: 1 }, e: { r: 3, c: 4 } },

      // Item Category
      { s: { r: 4, c: 1 }, e: { r: 4, c: 4 } },

      // Item Name ✅ FIXED
      { s: { r: 5, c: 1 }, e: { r: 5, c: 4 } }
    ];

    // 🔹 Apply Borders
    const range = XLSX.utils.decode_range(ws["!ref"]);
    for (let R = range.s.r; R <= range.e.r; R++) {
      for (let C = range.s.c; C <= range.e.c; C++) {
        const cellRef = XLSX.utils.encode_cell({ r: R, c: C });
        if (!ws[cellRef]) continue;

        ws[cellRef].s = {
          ...ws[cellRef].s,
          border: {
            top: { style: "thin", color: { rgb: "000000" } },
            bottom: { style: "thin", color: { rgb: "000000" } },
            left: { style: "thin", color: { rgb: "000000" } },
            right: { style: "thin", color: { rgb: "000000" } }
          }
        };
      }
    }

    // 🔹 Create Workbook
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

    XLSX.writeFile(wb, "Stock Ledger Report.xlsx");
  };



  const downloadPDF = () => { };

  useEffect(() => {
    const today = new Date();
    const currentYear = today.getFullYear();
    const automaticFromDate = `${currentYear}-01-01`;
    setFromDate(automaticFromDate);

    const formattedToDate = today.toISOString().split("T")[0];
    setToDate(formattedToDate);
  }, []);

  const stockLedgerReportFieldsChange = (value, name) => {
    
    setStockLedgerReportFields({
      ...stockLedgerReportFields,
      [name]: value.value,
    });

  };
  useEffect(() => {
    BindStockLedgerDDValues();
  }, []);

  const BindStockLedgerDDValues = async () => {
    const data = {
      mstClientId: mstClientId,
    };
    const response = await BindPostAPI(
      data,
      "StockReportAPI/BindStockLedgerDDValues"
    );

    if (response && response.data) {
      const itemTypeDD = response?.data.Table.map((item) => ({
        value: item.MstItemTypeId,
        label: item.ItemType,
      }));

      setBindItemType(itemTypeDD);

      const itemCategory = response?.data.Table1.map((item) => ({
        value: item.MstItemCategoryId,
        label: item.ItemCategory,
        type: item.MstItemTypeId,
      }));
      setBindItemCategory(itemCategory);

      const itemDD = response?.data.Table2.map((item) => ({
        value: item.MstItemId,
        label: item.ItemName,
        category: item.MstItemCategoryId,
      }));
      setBindItem(itemDD);
    }
  };

  const handleFieldsChange = (value, name) => {

    setStockLedgerReportFields({
      ...stockLedgerReportFields,
      [name]: value,
    });
  };



  return (
    <MainLayout pageName="4">
      <div>
        <div class="relative m-3 bg-white rounded-lg ">
          <div class="mt-3 py-4">
            <div className={mainTable.headerTitle}>
              <div className="my-2 mx-12 lg:mx-0">{`Stock Ledger Report`}</div>
            </div>
            <div class="mt-3">
              <div className={mainTable.grid3}>

                <AutoDropDown
                  selectedOption={
                    bindItemType.find(
                      (x) => x.value == stockLedgerReportFields.itemType
                    )}
                  title="Item Type"
                  classStar={"text-red-500"}
                  inputType="dropdown"
                  options={bindItemType}
                  name="itemType"
                  controlFunc={(e) => {
                    
                    setShowTable(false);

                    // update selected item type
                    stockLedgerReportFieldsChange(e, "itemType");

                    const filteredCategories = bindItemCategory.filter(
                      (v) => v.type === e.value
                    );

                    setBindItemCategoryDD(filteredCategories);
                    setBindItemDD([]);
                  }}
                  controlFuncBlur={() => {
                    setStockLedgerReportFieldsError(() => ({
                      ...stockLedgerReportFieldsError,
                      itemTypeError: stockLedgerReportFields.itemType ? "" : "Select Item Type",
                    }));
                  }}

                  errorMessage={stockLedgerReportFieldsError.itemTypeError}
                  placeholder="Select Item Type"
                  Class="custom-class"
                  tabIndex="1"
                />


                <AutoDropDown
                  selectedOption={
                    bindItemCategoryDD.find(
                      (x) => x.value == stockLedgerReportFields.itemCategory
                    )}
                  title="Item Category"
                  classStar={"text-red-500"}
                  inputType="dropdown"
                  options={bindItemCategoryDD}
                  name="itemCategory"
                  controlFunc={(e) => {
                    
                    setShowTable(false);
                    stockLedgerReportFieldsChange(e, "itemCategory");
                    // filter items based on new categories

                    const filteredItems = bindItem.filter(
                      (v) => v.category === e.value
                    );
                    setBindItemDD(filteredItems);
                  }}
                  controlFuncBlur={() => {
                    setStockLedgerReportFieldsError(() => ({
                      ...stockLedgerReportFieldsError,
                      itemCategoryError: stockLedgerReportFields.itemCategory ? "" : "Select Item Category",
                    }));
                  }}

                  errorMessage={stockLedgerReportFieldsError.itemCategoryError}
                  placeholder="Select Item Category"
                  Class="custom-class"
                  tabIndex="1"
                />

                <AutoDropDown
                  selectedOption={
                    bindItemDD.find(
                      (x) => x.value == stockLedgerReportFields.item
                    )}
                  title="Item"
                  classStar={"text-red-500"}
                  inputType="dropdown"
                  options={bindItemDD}
                  name="itemCategory"
                  controlFunc={(e) => {
                    setShowTable(false);
                    stockLedgerReportFieldsChange(e, "item");
                  }}
                  controlFuncBlur={() => {
                    setStockLedgerReportFieldsError(() => ({
                      ...stockLedgerReportFieldsError,
                      itemError: stockLedgerReportFields.item ? "" : "Select Item",
                    }));
                  }}

                  errorMessage={stockLedgerReportFieldsError.itemError}
                  placeholder="Select Item"
                  Class="custom-class"
                  tabIndex="1"
                />



              </div>
              <div class={mainTable.grid3}>
                <InputText
                  inputType="date"
                  title="From"
                  name="fromDate"
                  content={fromDate}
                  controlFunc={(e) => {
                    setShowTable(false);
                    setFromDate(e.target.value);
                  }}
                />
                <InputText
                  inputType="date"
                  title="To"
                  name="toDate"
                  content={toDate}
                  controlFunc={(e) => {
                    setShowTable(false);
                    setToDate(e.target.value);
                  }}
                />
                <div class="flex justify-start items-center mt-6">
                  <button
                    type="button"
                    onClick={() => GoButton()}
                    className={mainTable.addButton}
                  >
                    GO
                  </button>
                </div>
              </div>
            </div>
          </div>
          {showTable &&
            (bindStockLedgerReports.length > 0 ? (
              <div className=" ">
                <ReportGridPage
                  title=""
                  header={stockLedgerReportHeaders}
                  records={bindStockLedgerReports}
                  handleExport={handleExport}
                  handlePDF={downloadPDF}
                  xScroll=" max-md:w-fit w-full"
                />
              </div>
            ) : (
              <div className="flex items-center justify-center">
                No record found
              </div>
            ))}
        </div>
      </div>
    </MainLayout>
  );
};

export default StockLedgerReport;
